<template>
  <div v-if="cellData" class="rescell">
    <div class="rescellindicator" :style="getThresholdColorInternal()" />
    <div>
      <div class="rescelllw" >
        {{ getResult() }}
      </div>
    </div>
  </div>
</template>
<script>

import ThresholdColor from '@/mixins/ThresholdColor';

export default {
  
  mixins: [ ThresholdColor ],

  props: {
    cellData: { type: Object, default: () => {} },
    thresholds: null,
    percentageNumberOfDecimalPoints: {type: Number, default: 2},
    placeholderNaN: {type: String, default: 'N/A'}
  },

  mounted() {
    // console.log('ResultTable - mounted');
    this.extractResult();
  },

  data() {
    return {
      resultVal: undefined,
    };
  },

  methods: {

    extractResult() {
      if (this.cellData) {
        if (typeof this.cellData.value === 'string')
        {
          this.resultVal = Number(this.cellData.value.replace(',','.'));
        }
        else {
          this.resultVal = Number(this.cellData.value);
        }
      }
    },

    getResult() {
      //console.log('getResult');
      var retVal = this.placeholderNaN;

      if (this.resultVal != null && this.resultVal != undefined && !Number.isNaN(this.resultVal)) {
        retVal = (this.resultVal == 100 ? 
          this.$n(this.resultVal, { minimumFractionDigits: 0, maximumFractionDigits: 0}) :
          this.$n(this.resultVal, { minimumFractionDigits: this.percentageNumberOfDecimalPoints, maximumFractionDigits: this.percentageNumberOfDecimalPoints})) + '%';
      }

      return retVal;
    },

    getThresholdColorInternal() {
      let retVal = '';
      
      if (!isNaN(this.resultVal)) {
        retVal = 'background-color: ' + this.getThresholdColor(this.thresholds, this.resultVal, '#fff') + ';';
      }

      return retVal;
    }
  }
};
</script>
<style>

.rescellindicator {
  margin-top: 2px;
  width: 15px;
  height: 15px;
}

.rescell{
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 2rem;
}

.rescelllw, .rescellaw, .rescellnow {
  margin-left: 3px;
  height: 1rem;
}

.rescellnow {
  width: 0%;
}

</style>
